import { db } from "@/firebase"

const materialsRef = db.collection("materials");
 
const createMaterials = async (materials) => {
    try {
        const result = await materialsRef.add(materials)

        await result.update({ id_doc: result.id})

        return result.id;
    } catch (err) {
        throw new Error("Error while creating materials", err);
    }
}

const getMaterialsById = async (idMaterial) => {
    try {
        const docRef = materialsRef.doc(idMaterial);
        const docSnapshot = await docRef.get();

        if (!docSnapshot.exists) throw new Error("Material não encontrado");

        const materialData = docSnapshot.data();
        const movementsSnapshot = await docRef.collection('movements').get();

        materialData.movements = movementsSnapshot.docs
            .map(doc => ({...doc.data() }))
            .sort((a, b) =>
                (b.createdAt.seconds * 1e9 + b.createdAt.nanoseconds) -
                (a.createdAt.seconds * 1e9 + a.createdAt.nanoseconds)
            );

        return [true, materialData];
    } catch (err) {
        throw new Error("Erro ao buscar material e movimentos: " + err.message);
    }
};


const updateMaterials = async (idMaterial, updatedMaterials) => {
    try {
        const actualMaterial = await materialsRef.doc(idMaterial);
        await actualMaterial.update(updatedMaterials);

        return [true, updatedMaterials];

    } catch (err) {
        throw new Error("Error while updating materials", err);
    }
}

const saveMovement = async (idMaterial, movement, id_doc = null) => {
    try {
        const docRef = materialsRef.doc(idMaterial);
        const movementRef = docRef.collection('movements');

        const docSnapshot = await docRef.get();
        if (!docSnapshot.exists) {
            throw new Error("Material não encontrado");
        }

        let savedMovement;

        if (id_doc) {
            const movementDocRef = movementRef.doc(id_doc);
            const movementDocSnapshot = await movementDocRef.get();

            if (!movementDocSnapshot.exists) {
                throw new Error("Movimento não encontrado");
            }

            await movementDocRef.update(movement);
            const updatedMovementSnapshot = await movementDocRef.get();
            savedMovement = updatedMovementSnapshot.data();
        } else {
            const result = await movementRef.add(movement);
            await result.update({ id_doc: result.id })
            const updateSnapshot = await result.get()
            savedMovement = updateSnapshot.data();
        }

        return [true, savedMovement];
    } catch (err) {
        throw new Error("Erro ao salvar movimento: " + err.message);
    }
};


const removeMovement = async (idMaterial, idDoc) => {
    try {
        // Obtém o documento do material pelo ID
        const docRef = materialsRef.doc(idMaterial);
        const docSnapshot = await docRef.get();

        if (!docSnapshot.exists) {
            throw new Error("Material não encontrado");
        }

        // Referencia a subcoleção 'movements' e o documento pelo idDoc
        const movementDocRef = docRef.collection('movements').doc(idDoc);
        const movementDocSnapshot = await movementDocRef.get();

        if (!movementDocSnapshot.exists) {
            throw new Error("Movimento não encontrado");
        }

        // Remove o documento da subcoleção
        await movementDocRef.delete();

        return [true, `Movimento com id ${idDoc} removido com sucesso`];
    } catch (err) {
        throw new Error("Erro ao remover movimento: " + err.message);
    }
};

export default {
    createMaterials,
    getMaterialsById,
    updateMaterials,
    saveMovement,
    removeMovement,
}
